import path from 'node:path'

export class SchemaNotFoundError extends Error {
  constructor(name: string, schemasDir: string) {
    super(
      `Schema "${name}" not found. Looked in:\n  - ${path.join(schemasDir, `${name}.json`)}\n  - ${path.join(schemasDir, 'forms', `${name}.json`)}`
    )
    this.name = 'SchemaNotFoundError'
  }
}
